import { writable } from "svelte/store";
function createGlobalTaxFormDataStore() {
    const { subscribe, set, update } = writable(new Map());
    return {
        subscribe,
        set,
        update,
        delete: (serviceNumber) => {
            update(globalTaxFormData => {
                globalTaxFormData.delete(serviceNumber);
                return globalTaxFormData;
            });
        },
        setTaxFormData: (serviceNumber, taxFormData) => {
            update(globalTaxFormData => {
                globalTaxFormData.set(serviceNumber, taxFormData);
                return globalTaxFormData;
            });
        },
    };
}
export const globalTaxFormData = createGlobalTaxFormDataStore();
export const adapterNumber = writable(0);
